import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createCampaignClient, type CampaignClient, type CampaignClientConfig } from './create-campaign-client';

interface CampaignContextValue {
  config: CampaignClientConfig;
  client: CampaignClient;
}

const CampaignContext = createContext<CampaignContextValue | undefined>(undefined);

export interface CampaignProviderProps {
  children: ReactNode;
  config: CampaignClientConfig;
}

export function CampaignProvider({ children, config }: CampaignProviderProps) {
  const client = useMemo(() => createCampaignClient(config), [config]);
  const value = useMemo(() => ({ config, client }), [client, config]);
  return <CampaignContext.Provider value={value}>{children}</CampaignContext.Provider>;
}

export function useCampaignContext(): CampaignContextValue {
  const context = useContext(CampaignContext);
  if (!context) {
    throw new Error('useCampaignContext must be used within CampaignProvider');
  }
  return context;
}
